import React from 'react';
import PropTypes from 'prop-types';

import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import classNames from 'classnames';
import { css, StyleSheet } from 'aphrodite';

import { grey } from 'lib/css/colors';

function UPBL5PercentageGMVBadge({ percentage }) {
  if (!percentage || percentage === 0) {
    return null;
  }

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id={`gmv-percentage-tooltip`} className={css(styles.tooltip)}>
          {percentage}%
        </Tooltip>
      }
    >
      <Badge variant="secondary" className={classNames(css(styles.badge), 'px-2')}>
        {percentage?.toFixed(2)}%
      </Badge>
    </OverlayTrigger>
  );
}

const styles = StyleSheet.create({
  badge: {
    borderRadius: 9,
    fontSize: '0.80rem',
    backgroundColor: grey,
  },
  tooltip: {
    borderRadius: '12px',
    padding: '8px 12px',
    fontSize: '0.85rem',
  },
});

UPBL5PercentageGMVBadge.propTypes = {
  percentage: PropTypes.number,
};

export default UPBL5PercentageGMVBadge;
